module.exports = __webpack_public_path__ + "static/lascaux_control_01-22eb7df75ddc48fcb4a99672aaf540b7.png";